export enum StationState {
  NotActive = 0,
  Free = 1,
  Occupied = 2,
  Maintenance = 3,
  Reserved = 4,
  Unknown = 5,
  Preparing = 6,
}
